<template>
  <el-col :span="config.span" @click.native.stop="$emit('activeItem', config)" :class="(config.refs+'--'+new Date().getTime())">
    <el-form-item
      :label="config.label"
      :prop="config.prop || config.key"
      :rules="config.regList"
      :required="config.required"
    >
      <slot name="content"></slot>
      <!-- 输入框 -->
      <el-input
        v-if="config.type == 'input' && config.isShow"
        :disabled="config.disabled"
        :placeholder="config.placeholder"
        v-model="searchValue"
        :clearable="config.clearable"
        :suffix-icon="config.suffixIcon"
        :prefix-icon="config.prefixIcon"
        :size="config.size"
        :show-password="config.showPassword"
        :maxlength="config.maxlength ? config.maxlength : 9999999999"
        :show-word-limit="config.showWordLimit"
        :readonly="config.readonly"
        @change="$emit('change', searchValue)"
      >
        <template v-if="config.prepend" #prepend>
          {{ config.prepend }}
        </template>
        <template v-if="config.append" #append>
          {{ config.append }}
        </template>
      </el-input>
      <!-- 多行文本 -->
      <el-input
        type="textarea"
        v-if="config.type == 'textarea' && config.isShow"
        :disabled="config.disabled"
        :placeholder="config.placeholder"
        :clearable="config.clearable"
        v-model="searchValue"
        :autosize="config.autosize"
        :maxlength="config.maxlength"
        :readonly="config.readonly"
        :show-word-limit="config.showWordLimit"
        @change="$emit('change', searchValue)"
      >
      </el-input>
      <!-- 下拉框 -->
      <el-select
        v-if="config.type == 'select' && config.selectData && config.isShow"
        :disabled="config.disabled"
        v-model="searchValue"
        :placeholder="config.placeholder"
        :clearable="config.clearable"
        :multiple="config.multiple"
        :multiple-limit="config.multipleLimit"
        :filterable="config.filterable"
        :allow-create="config.allowCreate"
        default-first-option
        @change="$emit('change', searchValue)"
        @remove-tag="val => $emit('remove-tag', val)"
        @clear="$emit('clear')"
      >
        <template v-if="$slots.prefix" #prefix>
          <slot name="prefix"></slot>
        </template>
        <el-option
          :value="el[config.propsState.value]"
          v-for="(el, i) in config.selectData"
          :key="i"
          :label="el[config.propsState.label]"
          :disabled="el.disabled"
        >
          <slot name="customize"></slot>
        </el-option>
      </el-select>
      <!-- 单选框 -->
      <el-radio-group
        v-if="config.type == 'radio' && config.isShow"
        :size="config.size"
        :disabled="config.disabled"
        :text-color="config.textColor"
        :fill="config.fill"
        v-model="searchValue"
        @change="$emit('change', searchValue)"
      >
        <template v-if="config.optionType == 'default'">
          <el-radio
            :border="config.border"
            v-for="(el, i) in config.selectData"
            :label="el.value"
            :key="i"
            >{{ el.label }}</el-radio
          >
        </template>
        <template v-else>
          <el-radio-button
            v-for="(el, i) in config.selectData"
            :label="el.value"
            :key="i"
            >{{ el.label }}</el-radio-button
          >
        </template>
      </el-radio-group>
      <!-- 多选框 -->
      <el-checkbox-group
        v-if="config.type == 'checkbox' && config.selectData && config.isShow"
        :size="config.size"
        :min="config.min"
        :max="config.max"
        :text-color="config.textColor"
        :fill="config.fill"
        :disabled="config.disabled"
        v-model="searchMoreValue"
        @change="$emit('change', searchMoreValue)"
      >
        <template v-if="config.optionType == 'default'">
          <el-checkbox
            v-for="(el, i) in config.selectData"
            :label="el.value"
            :key="i"
            :disabled="el.disabled"
            :border="config.border"
            :size="el.size"
            :checked="el.checked"
            :indeterminate="el.indeterminate"
          >
            {{ el.label }}
          </el-checkbox>
        </template>
        <template v-else>
          <el-checkbox-button
            v-for="(el, i) in config.selectData"
            :label="el.value"
            :key="i"
            :disabled="el.disabled"
          >
            {{ el.label }}
          </el-checkbox-button>
        </template>
      </el-checkbox-group>
      <!-- 级联选择器 -->
      <el-cascader
        v-if="config.type == 'cascader' && config.isShow"
        v-model="searchValue"
        :size="config.size"
        :options="config.selectData"
        :disabled="config.disabled"
        :clearable="config.clearable"
        :show-all-levels="config.showAllLevels"
        :collapse-tags="config.collapseTags"
        :filterable="config.filterable"
        :separator="config.separator"
        :filter-method="
          (node, keyword) => $emit('filter-method', node, keyword)
        "
        :props="config.propsState"
        @change="$emit('change', searchValue)"
        @remove-tag="val => $emit('remove-tag', val)"
      >
        <template #default="{node,data}">
          <slot :node="node" :data="data"></slot>
        </template>
      </el-cascader>
      <!-- 开关 -->
      <el-switch
        v-if="config.type == 'switch' && config.isShow"
        v-model="searchValue"
        :disabled="config.disabled"
        :active-color="config.activeColor"
        :inactive-color="config.inactiveColor"
        :active-text="config.activeText"
        :inactive-text="config.inactiveText"
        :active-value="config.activeValue"
        :inactive-value="config.inactiveValue"
        @change="$emit('change', searchValue)"
      >
      </el-switch>
      <!-- 计数器 -->
      <el-input-number
        v-if="config.type == 'number' && config.isShow"
        v-model="searchValue"
        :disabled="config.disabled"
        :size="config.size"
        :min="config.min"
        :max="config.max"
        :step="config.step"
        :precision="config.precision"
        :controls-position="config.controlsPosition"
        @change="$emit('change', searchValue)"
        @select="$emit('change', searchValue)"
      ></el-input-number>
      <!-- 滑块 -->
      <el-slider
        v-if="config.type == 'slider' && config.isShow"
        v-model="searchValue"
        :show-tooltip="config.showTooltip"
        :disabled="config.disabled"
        :step="config.step"
        :show-stops="config.showStops"
        :show-input="config.showInput"
        :range="config.range"
        :min="config.min"
        :max="config.max"
        :vertical="config.vertical"
        :height="config.height"
        :marks="config.marks"
        :format-tooltip="formatTool"
        @change="$emit('change', searchValue)"
      ></el-slider>
      <!-- 固定时间选择 -->
      <el-time-select
        v-if="config.type == 'fixTime' && config.isShow"
        v-model="searchValue"
        :placeholder="config.placeholder"
        :disabled="config.disabled"
        :readonly="config.readonly"
        :prefix-icon="config.prefixIcon"
        :clearable="config.clearable"
        :size="config.size"
        :picker-options="config.pickerOptions"
        :default-value="config.defaultValue"
        @change="$emit('change', searchValue)"
      >
      </el-time-select>
      <!-- 时间选择 -->
      <el-time-picker
        v-if="config.type == 'timeSelect' && config.isShow"
        v-model="searchValue"
        :placeholder="config.placeholder"
        :disabled="config.disabled"
        :readonly="config.readonly"
        :prefix-icon="config.prefixIcon"
        :clearable="config.clearable"
        :size="config.size"
        :picker-options="config.pickerOptions"
        :default-value="config.defaultValue"
        @change="$emit('change', searchValue)"
      >
      </el-time-picker>
      <!-- 时间范围选择 -->
      <el-time-picker
        v-if="config.type == 'timeRangeSelect' && config.isShow"
        v-model="searchValue"
        :placeholder="config.placeholder"
        :disabled="config.disabled"
        :format="config.format"
        :readonly="config.readonly"
        :prefix-icon="config.prefixIcon"
        :clearable="config.clearable"
        :value-format="config.valueFormat"
        :size="config.size"
        :is-range="config.isRange"
        :start-placeholder="config.startPlaceholder"
        :end-placeholder="config.endPlaceholder"
        :range-separator="config.rangeSeparator"
        :default-value="config.defaultValue"
        @change="$emit('change', searchValue)"
      >
      </el-time-picker>
      <!-- 日期选择 -->
      <el-date-picker
        v-if="config.type == 'date' && config.isShow"
        :type="config.dataType"
        v-model="searchValue"
        :disabled="config.disabled"
        :clearable="config.clearable"
        :size="config.size"
        :placeholder="config.placeholder"
        :picker-options="config.pickerOptions"
        :format="config.format"
        :prefix-icon="config.prefixIcon"
        :readonly="config.readonly"
        :value-format="config.valueFormat"
        @change="$emit('change', searchValue)"
      >
      </el-date-picker>
      <!-- 日期范围选择 -->
      <el-date-picker
        v-if="config.type == 'daterange' && config.isShow"
        :type="config.dataType"
        v-model="searchValue"
        :disabled="config.disabled"
        :clearable="config.clearable"
        :size="config.size"
        :placeholder="config.placeholder"
        :picker-options="config.pickerOptions"
        :format="config.format"
        :readonly="config.readonly"
        :prefix-icon="config.prefixIcon"
        :range-separator="config.rangeSeparator"
        :start-placeholder="config.startPlaceholder"
        :end-placeholder="config.endPlaceholder"
        :value-format="config.valueFormat"
        :default-value="config.defaultValue"
        @change="$emit('change', searchValue)"
      >
      </el-date-picker>
      <!-- 评分 -->
      <el-rate
        v-if="config.type == 'rate'"
        v-model="searchValue"
        :disabled="config.disabled"
        :max="config.max"
        :show-score="config.showScore"
        :text-color="config.textColor"
        :allow-half="config.allowHalf"
        :show-text="config.showText"
        @change="$emit('change', searchValue)"
      >
      </el-rate>
      <!-- 颜色选择 -->
      <el-color-picker
        v-if="config.type == 'colorPicker'"
        v-model="searchValue"
        :disabled="config.disabled"
        :size="config.size"
        :show-alpha="config.showAlpha"
        :color-format="config.colorFormat"
        @change="$emit('change', searchValue)"
      >
      </el-color-picker>
      <!-- 金额范围选择 -->
      <rangeSelect v-if="config.type=='range' && config.isShow" :disabled="config.disabled" @change="(val)=>$emit('change', val)" :timeInfo="[searchMoreValue[0],searchMoreValue[1]]" />
      <el-color-picker
        v-if="config.type == 'colorPicker'"
        v-model="searchValue"
        :disabled="config.disabled"
        :size="config.size"
        :show-alpha="config.showAlpha"
        :color-format="config.colorFormat"
        @change="$emit('change', searchValue)"
      >
      </el-color-picker>
      <!-- 上传 -->
      <uploadFiles v-if="config.type == 'upload'" :uploadData="config" 
            @preview="()=>$emit('preview')"
            @responed="(data)=>$emit('responed', data)"
            @error="(file, fileList)=>$emit('error', file, fileList)"
            @onProgress="(event, file, fileList)=>$emit('onProgress', event, file, fileList)"
            @change="( file, fileList)=>$emit('change', file, fileList)"
            @fileList="(fileList)=>$emit('fileList', fileList)"
            @fileListChange="(ids)=>$emit('fileListChange', ids)"
            @fileUrl="(url)=>$emit('fileUrl', url)"
            @beforeUpload="(file)=>$emit('beforeUpload', file)"
            @beforeRemove="(file, fileList)=>$emit('beforeRemove', file, fileList)"
      ></uploadFiles>
      <!-- 富文本编辑 -->
        <VueUeditorWrap 
            v-if="config.type == 'editor'" 
            v-model="searchValue" 
            :editor-id="config.editorId" 
            :disabled="config.disabled"
            :ref="config.refs"
            :config = "config" 
            @before-init="(string)=>$emit('before-init',string)" 
            @ready="(val)=>$emit('ready',val)">
        </VueUeditorWrap>
    </el-form-item>
  </el-col>
</template>

<script>
import uploadFiles from '@/components/utils/upload'
import rangeSelect from '@/components/range_select'
export default {
   components:{ uploadFiles ,rangeSelect},
  data() {
    return {
      //单个值
      searchValue: null,
      //多个值
      searchMoreValue: [],
      valids: [],
      handleValidate: (rule, value, callback, element) => {
        if (this.searchValue) {
          //new RegExp不需要前后斜杠/ /
          let z_reg = new RegExp(element.pattern);
          if (z_reg.test(this.searchValue)) {
            callback();
          } else {
            callback(element.message);
          }
        }
      }
    };
  },
  props: {
    config: {
      require: true,
      default: () => {
        return {};
      }
    },
    value: {
      require: true,
      default: ""
    }
  },
  watch: {
    //默认值
    "config.defaultValue": {
      handler() {
        this.searchValue = this.config.defaultValue;
      },
      deep: true
    },
    //对象model
    value: {
      handler(newVal) {
        if(typeof this.config.key == 'object'){
            this.config.key.map((a,i)=>{
                this.$set(this,'searchValue',newVal[this.config.key])
                this.$set(this.searchMoreValue,i,newVal[a])
            })
        }else{
            this.$set(this,'searchValue',newVal[this.config.key])
        }
      },
      deep: true
    },
    //正则校验变化
    "config.regList": {
      handler(newVal) {
        this.valids = [];
        if (newVal.length > 0) {
          this.valids = newVal.map(a => {
            return {
              validator: (rule, value, callback) =>
                this.handleValidate(rule, value, callback, a)
            };
          });
        }
      },
      deep: true
    }
  },
  created() {
    //单个值
    this.searchValue = this.value[this.config.key];
    //多个值
    this.searchMoreValue = this.searchValue || [];
  },
  methods: {
    timeStart(val) {
      this.searchMoreValue[0] = val;
      this.$emit("startChange", val);
    },
    endTime(val) {
      this.searchMoreValue[1] = val;
      this.$emit("endChange", val);
    },
    //滑块格式化配置
    formatTool() {
      if (this.config.formatTooltip) {
        this.$emit("formatTooltip");
      } else {
        () => {
          return 0;
        };
      }
    }
  }
};
</script>

<style lang="scss" scoped>
    @import "@/assets/css/form.scss";
</style>
